import { appPaths } from '@terminal/routes/app-paths';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { useNavigate, useParams } from 'react-router';

interface NavigateToThemeProps {
  themeId?: string;
  source: PosthogTrackingSource;
  searchParams?: URLSearchParams;
}

export const useNavigateToThemeOverview = () => {
  const navigate = useNavigate();
  const { themeId: currentThemeId } = useParams();
  const { trackThemeOpen } = usePosthogEvents();

  const navigateToThemeOverview = (
    themeId: string,
    source: PosthogTrackingSource
  ) => {
    if (currentThemeId !== themeId) {
      trackThemeOpen(source, [themeId]);
    }

    navigate({
      pathname: `${appPaths.themeOverview}/${themeId}`,
    });
  };

  const navigateToTheme = ({
    themeId,
    source,
    searchParams,
  }: NavigateToThemeProps) => {
    if (!themeId) {
      return;
    }

    if (currentThemeId !== themeId) {
      trackThemeOpen(source, [themeId]);
    }

    const newSearchParams = new URLSearchParams(searchParams);

    navigate({
      pathname: `${appPaths.themeOverview}/${themeId}`,
      search: newSearchParams.toString(),
    });
  };

  return {
    navigateToThemeOverview,
    navigateToTheme,
  };
};
